var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo-link white--text",attrs:{"to":{ name: 'home' }}},[_c('img',{staticClass:"mt-2",attrs:{"src":require("../../../assets/logo-white.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }